/** 해당 쿼터 키로 업데이트 이벤트 발송 (각 페이지에서 API 성공 후 호출) */
export function dispatchQuotaUpdated(queryType) {
    if (queryType) {
        window.dispatchEvent(new CustomEvent(`${queryType}QuotaUpdated`));
    }
}
